const triggerClass = '.js-edit-table-toggle'
const targetClass = '.js-filter-table-edit'
const parentClass = '.i-filter-table-wrapper'
const activeClass = 'js-edit-active'

document.addEventListener("DOMContentLoaded", function() {
  editFilterTableTrigger()
});


const editFilterTableTrigger = () => {
  const triggers = document.querySelectorAll(triggerClass)
  const targets = document.querySelectorAll(targetClass)

  if(!triggers || !targets) return

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()
      handleOpenEditFilter(event)
    })
  })
}

const handleOpenEditFilter = (event) => {

  const button = event.target
  const rowWrapper = button.closest(parentClass)
  const targetArea = rowWrapper.querySelector(targetClass)
  const allTextAreas = document.querySelectorAll(targetClass)
  const allButtons = document.querySelectorAll(triggerClass)
  const realTarget = button.closest(triggerClass)

  allTextAreas.forEach(ta => {
    ta.classList.remove(activeClass)
  })

  if(realTarget.classList.contains(activeClass)) {
    realTarget.classList.remove(activeClass)
    return
  }

  allButtons.forEach(btn => {
    btn.classList.remove(activeClass)
  })

  targetArea.classList.add(activeClass)
  realTarget.classList.add(activeClass)

}
